import { render } from "./VueBottomSheet.vue?vue&type=template&id=5b6acf44&scoped=true"
import script from "./VueBottomSheet.vue?vue&type=script&lang=js"
export * from "./VueBottomSheet.vue?vue&type=script&lang=js"

import "./VueBottomSheet.vue?vue&type=style&index=0&id=5b6acf44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b6acf44"

export default script